import {Box, Button, Stack, Typography} from '@mui/material';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {AlertInfo, EmptySearchState} from 'presentation/components';
import {Loading} from 'presentation/components/Loading/Loading';
import {PhonesDrawer} from 'presentation/components/PhonesDrawer';
import {PhonesMenu} from 'presentation/components/PhonesMenu';
import {translations} from 'presentation/translations-new';
import React, {Fragment} from 'react';
import {useSpecialtyNotAvailableOnlineCard} from './hooks/useSpecialtyNotAvailableOnlineCard';
import {StyledCard} from './styles';
import {SpecialtyNotAvailableOnlineCardProps} from './types';

const {call, callToChat} = translations['pt-br'].commons;
const {unitsFlow} = translations['pt-br'].privateFlow.bookingFlow;
const {choosePhoneNumber} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow.unitDetails;
const {selfNetwork} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow;

export const SpecialtyNotAvailableOnlineCard = ({
	selfNetworkVariant,
}: SpecialtyNotAvailableOnlineCardProps) => {
	const {
		handleClosePhoneMenu,
		handleTogglePhoneDrawer,
		handleOpenPhoneMenu,
		handleCallChatRoom,
		isPhoneNumberMenuOpen,
		openPhoneDrawerState,
		phoneNumbers,
		phoneNumbersAlert,
		anchorEl,
		callChatRoomIsLoading,
		isMobile,
		shouldReverseNetworkOrder,
	} = useSpecialtyNotAvailableOnlineCard();

	return (
		<Fragment>
			{selfNetworkVariant ? (
				<Stack gap={1.5} mt={shouldReverseNetworkOrder ? 2 : 0}>
					<Typography variant="subtitle1" color="text.secondary" fontWeight={600}>
						{selfNetwork.title}
					</Typography>

					<StyledCard elevation={0}>
						<Stack gap={2}>
							<Stack gap={0.5}>
								<Typography variant="h6">
									{unitsFlow.notFoundModal.specialtyNotAvailableOnlineTitle}
								</Typography>
								<Typography variant="body1" color="text.primary">
									{unitsFlow.notFoundModal.specialtyNotAvailableOnlineDescription}
								</Typography>
							</Stack>
							<Stack gap={1}>
								<Button
									variant={'contained'}
									size="large"
									data-tag-id={
										AppointmentBookingEnum.CLICK_FALAR_COM_ATENDIMENTO_AGENDAMENTO
									}
									onClick={handleCallChatRoom}
									disabled={callChatRoomIsLoading}
									endIcon={
										callChatRoomIsLoading ? (
											<Loading size={16} color="inherit" />
										) : null
									}>
									{callToChat}
								</Button>
								<Button
									variant={'outlined'}
									size="large"
									data-tag-id={AppointmentBookingEnum.CLICK_LIGAR_AGENDAMENTO}
									onClick={handleOpenPhoneMenu}>
									{call}
								</Button>
							</Stack>
						</Stack>
					</StyledCard>
				</Stack>
			) : (
				<EmptySearchState
					title={unitsFlow.notFoundModal.specialtyNotAvailableOnlineTitle}
					description={unitsFlow.notFoundModal.specialtyNotAvailableOnlineDescription}
					imageV2>
					<Stack gap={2}>
						<Button
							onClick={handleCallChatRoom}
							size="large"
							disabled={callChatRoomIsLoading}
							endIcon={
								callChatRoomIsLoading ? <Loading size={16} color="inherit" /> : null
							}
							data-tag-id={
								AppointmentBookingEnum.CLICK_FALAR_COM_ATENDIMENTO_AGENDAMENTO
							}>
							{callToChat}
						</Button>
						<Button
							onClick={handleOpenPhoneMenu}
							size="large"
							variant="outlined"
							data-tag-id={AppointmentBookingEnum.CLICK_LIGAR_AGENDAMENTO}>
							{call}
						</Button>
					</Stack>
				</EmptySearchState>
			)}

			{isMobile ? (
				<PhonesDrawer.Root
					open={openPhoneDrawerState}
					toggleDrawer={handleTogglePhoneDrawer}
					title={choosePhoneNumber}>
					<AlertInfo.Root>{phoneNumbersAlert}</AlertInfo.Root>

					<PhonesDrawer.WithTitle phoneNumbers={phoneNumbers} />
				</PhonesDrawer.Root>
			) : (
				<PhonesMenu.Root
					open={isPhoneNumberMenuOpen}
					onClose={handleClosePhoneMenu}
					anchorEl={anchorEl}>
					<Box pb={2}>
						<AlertInfo.Root>{phoneNumbersAlert}</AlertInfo.Root>
					</Box>

					<PhonesDrawer.WithTitle phoneNumbers={phoneNumbers} />
				</PhonesMenu.Root>
			)}
		</Fragment>
	);
};
